import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';

function ReferralAddressBox({ referralAddress, handleOpenEditAddressForm, addressMissing }) {
  return (
    <div className="my-3">
      <p>Reward checks will be delivered to you at:</p>
      <div className="card" style={{ maxWidth: '25rem' }}>
        <div className="card-body clearfix">
          <div className="float-left">
            {addressMissing ? (
              <>
                {' '}
                <i>Let us know where to send your reward checks!</i>
                {' '}
                <div className="d-flex justify-content-center">
                  <div>
                    <button
                      type="button"
                      onClick={handleOpenEditAddressForm}
                      className="btn btn-link"
                    >
                      Submit mailing address
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <ul className="list-unstyled">
                <li>
                  {referralAddress.name}
                </li>
                <li>
                  {`${referralAddress.streetLine1} ${referralAddress.streetLine2 || ''}`}
                </li>
                <li>
                  {`${referralAddress.locality}, ${referralAddress.state} ${referralAddress.postalCode}`}
                </li>
                <li>
                  {referralAddress.country}
                </li>
              </ul>
            )}

          </div>
          {!addressMissing && (
          <div className="float-right">
            <button
              className="btn btn-link"
              style={{ textDecoration: 'none' }}
              type="button"
              onClick={handleOpenEditAddressForm}
            >
              {' '}
              Edit
              {' '}
              <Icon icon="pencil" />
            </button>
          </div>
          )}
        </div>
      </div>
    </div>
  );
}

ReferralAddressBox.defaultProps = {
  referralAddress: {},
};

ReferralAddressBox.propTypes = {
  referralAddress: PropTypes.shape({
    name: PropTypes.string,
    streetLine1: PropTypes.string,
    streetLine2: PropTypes.string,
    locality: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string,
  }),
  handleOpenEditAddressForm: PropTypes.func.isRequired,
  addressMissing: PropTypes.bool.isRequired,
};

export default ReferralAddressBox;
